import { SettingName } from '@xemplo/business-unit-query';

export type SettingDefinition = {
  settingName: SettingName;
  label: string;
  helperText?: string;
};

export type SettingsSection = {
  id: string;
  title: string;
  description: string;
  settings: SettingDefinition[];
};

/**
 * Frontend-owned presentation of the integration settings: section grouping, ordering,
 * labels and helper text. The API supplies only values (enabled state per SettingName);
 * structure and copy live here. A setting absent from this config is not rendered.
 */
export const SETTINGS_SECTIONS: SettingsSection[] = [
  {
    id: 'integrations',
    title: 'Integrations',
    description: 'Changes will take effect for newly created pay runs and amendments',
    settings: [
      { settingName: SettingName.Payrun, label: 'Pay runs' },
      { settingName: SettingName.Amendment, label: 'Amendments' },
      { settingName: SettingName.KeypayReport, label: 'Reports' },
    ],
  },
  {
    id: 'finalisation-and-distribution',
    title: 'Finalisation and Distribution',
    description: 'Configure actions triggered when pay run is finalised',
    settings: [
      {
        settingName: SettingName.FinalisePayrun,
        label: 'Finalise external pay run and publish payslips',
        helperText: 'Payslips become available immediately when a pay run is finalised',
      },
      {
        settingName: SettingName.SendPayslips,
        label: 'Send payslips to workers at pay date and time',
        helperText:
          'Worker payslip notifications are scheduled for the configured pay date and time',
      },
    ],
  },
];
